import { push as redirectTo } from 'connected-react-router';

import {
  NETWORK_FAILURE,
  NETWORK_SUCCESS,
  SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_EMAIL,
  VERIFY_ACCOUNT_RECOVERY_EMAIL_OTP,
  SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_SMS,
  CREATE_ACCOUNT_RECOVERY_PASSWORD,
  VERIFY_ACCOUNT_RECOVERY_SMS_OTP,
} from 'constants/actionTypes';
import { sendAccountRecoverySMSOTPNotification } from 'redux/actions/accountRecovery.actions';
import { apiRequest } from 'redux/actions/api.actions';
import { checkUser } from 'redux/actions/auth.actions';
import { clearServerError } from 'redux/actions/ui.actions';
import handleSideEffects from 'redux/handleSideEffects';

export const verifyAccountRecoveryEmailOtpLabel =
  'verifyAccountRecoveryEmailOtp';
export const sendAccountRecoveryEmailOtpNotificationLabel =
  'sendAccountRecoveryEmailOtpNotification';
export const sendAccountRecoverySmsOtpNotificationLabel =
  'sendAccountRecoverySmsOtpNotification';
export const createAccountRecoveryPasswordLabel =
  'createAccountRecoveryPassword';
export const submitAccountRecoverySmsOtpLabel = 'submitAccountRecoverySmsOtp';

const accountRecoveryMiddleware = handleSideEffects({
  [SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_EMAIL]: dispatch => {
    dispatch(
      apiRequest({
        url: '/v1/recovery/email/send',
        method: 'POST',
        fromAction: SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_EMAIL,
        label: sendAccountRecoveryEmailOtpNotificationLabel,
      }),
    );
  },

  [VERIFY_ACCOUNT_RECOVERY_EMAIL_OTP]: (dispatch, { payload, meta }) => {
    dispatch(
      apiRequest({
        url: '/v1/recovery/email/verify',
        method: 'POST',
        body: { code: payload.code },
        fromAction: VERIFY_ACCOUNT_RECOVERY_EMAIL_OTP,
        label: verifyAccountRecoveryEmailOtpLabel,
        meta,
      }),
    );
  },

  [SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_SMS]: dispatch => {
    dispatch(
      apiRequest({
        url: '/v1/recovery/sms/send',
        method: 'POST',
        fromAction: SEND_USER_ACCOUNT_RECOVERY_OTP_NOTIFICATION_SMS,
        label: sendAccountRecoverySmsOtpNotificationLabel,
      }),
    );
  },

  [CREATE_ACCOUNT_RECOVERY_PASSWORD]: (dispatch, { payload }) => {
    dispatch(
      apiRequest({
        url: '/v1/recovery/password',
        method: 'POST',
        body: { password: payload.password },
        fromAction: CREATE_ACCOUNT_RECOVERY_PASSWORD,
        label: createAccountRecoveryPasswordLabel,
      }),
    );
  },

  [VERIFY_ACCOUNT_RECOVERY_SMS_OTP]: (dispatch, { payload, meta }) => {
    dispatch(
      apiRequest({
        url: '/v1/recovery/sms/verify',
        method: 'POST',
        body: { code: payload.code },
        fromAction: VERIFY_ACCOUNT_RECOVERY_SMS_OTP,
        label: submitAccountRecoverySmsOtpLabel,
        meta,
      }),
    );
  },

  [NETWORK_FAILURE]: (dispatch, { meta, payload }) => {
    if (meta.fromAction === VERIFY_ACCOUNT_RECOVERY_EMAIL_OTP) {
      const unauthorized = payload.error.status === 401;
      if (unauthorized) {
        dispatch(clearServerError(verifyAccountRecoveryEmailOtpLabel));
      }
    }
  },

  [NETWORK_SUCCESS]: (dispatch, { meta }) => {
    if (meta.fromAction === VERIFY_ACCOUNT_RECOVERY_EMAIL_OTP) {
      dispatch(sendAccountRecoverySMSOTPNotification());
      dispatch(
        redirectTo('/account-recovery/sms/verify', { recovery: meta.recovery }),
      );
    }

    if (meta.fromAction === CREATE_ACCOUNT_RECOVERY_PASSWORD) {
      dispatch(checkUser());
    }

    if (meta.fromAction === VERIFY_ACCOUNT_RECOVERY_SMS_OTP) {
      dispatch(
        redirectTo('/account-recovery/password', { recovery: meta.recovery }),
      );
    }
  },
});

export default accountRecoveryMiddleware;
